/**
 * Auth0 の callback が成功したときだけ立てる印。provider はこれを見てログインを送り、消す。
 * User ID の変化から推すと、デプロイ直後の既存セッションや新しいブラウザまでログインに数える。
 */
export const LOGIN_MARKER_COOKIE_NAME = "_sanu_login";

/** callback から最初の描画までに足りる長さ。読まれずに残っても後のログインと混ざらない */
export const LOGIN_MARKER_MAX_AGE = 5 * 60;

/** 印があれば消して true を返す。 */
export function consumeLoginMarker(): boolean {
  try {
    const present = document.cookie
      .split("; ")
      .includes(`${LOGIN_MARKER_COOKIE_NAME}=1`);
    if (present) {
      document.cookie = `${LOGIN_MARKER_COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;
    }
    return present;
  } catch {
    // cookie が無効なブラウザ。計測を止める理由にはしない。
    return false;
  }
}
